export default __webpack_public_path__ + "static/media/question-bank.d4fd9568.svg";